<template>
    <v-combobox
      type="text"
      dense
      outlined
      v-model="modelData"
      :label="placeholder"
      :name="name"
      :items="listaDeOptions"
      :item-text="optionLabel"
      :item-value="optionValue"
      :disabled="somenteLeitura"
      :multiple="selecaoMultipla"
      :chips="selecaoMultipla ? formatoBotao : false"      
      :error-messages="error"
      @change="$emit('change', $event)"
      :class="error ? 'show-errors' : 'hide-error'"
      placeholder="Selecione"      
    >
    </v-combobox>
</template>

<script>
export default {
  name: 'OSFormComboboxComponent',

  props: {
    error: {
      type: String
    },
    value: {
      // type: Object,
      required: true
    },
    validate: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    listaDeOptions: {
      type: Array,
      required: true,
    },
    optionLabel: {
      type: String,
      required: false,
      default: 'name'
    },
    optionValue: {
      type: String,
      required: false,
      default: 'id'
    },
    somenteLeitura: {
      type: Boolean,
      required: false,
      default: false
    },
    optionSelecione: {
      type: String,
      required: false,
      default: 'Selecione'
    },
    selecaoMultipla: {
      type: Boolean,
      required: false,
      default: false
    },
    formatoBotao: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    modelData: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      }
    }
  }
}
</script>

<style lang="scss" >
.hide-error.v-text-field--enclosed .v-text-field__details{
  display: none !important;
}
</style>
